/* ============================================================
   도메인 셸
   2026-05-13 App.tsx 분리
   ============================================================ */
import { DOMAIN_CARDS, DOMAIN_PANELS } from '../data'

export function DomainView({ code, openHome }: { code: string; openHome: () => void }) {
  const card = DOMAIN_CARDS.find(c => c.code === code)
  if (!card) return null
  const panels = DOMAIN_PANELS[code] || []

  return (
    <div>
      <div className="breadcrumb">
        <a onClick={openHome}>홈</a>
        <span className="sep">/</span>
        <span>프로그램 바로가기</span>
        <span className="sep">/</span>
        <span>{card.label}</span>
      </div>
      <div className="page-header">
        <h2>
          {card.label}
          <span className="meta-mono" style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 14, fontWeight: 400, color: 'var(--warm-gray)'
          }}>
            {card.code}
          </span>
        </h2>
        <div className="desc">{card.desc}</div>
      </div>
      <div className="domain-empty">
        <div className="mark">◐</div>
        <div className="title">{card.label} 셸</div>
        <div className="phase">PHASE 2 — REACT 진입 후 구축 예정</div>
        <div className="panels">
          {panels.map(p => (
            <span key={p} className="panel-tag">{p}</span>
          ))}
        </div>
        <div style={{
          marginTop: 24, fontSize: 13, color: 'var(--warm-gray)',
          maxWidth: 560, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.7,
        }}>
          이 도메인 셸 안에서 위 영역들이 통합 대시보드로 펼쳐집니다.<br />
          태스크 입력·수정·삭제는 자동으로{' '}
          <strong style={{ color: 'var(--accent-green)' }}>v_tasks_all + MG 일정관리</strong>
          에 양방향 동기화됩니다.
        </div>
      </div>
    </div>
  )
}
